"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSectionList = createSectionList;
const createCurrentCardiologicalState_1 = require("./createCurrentCardiologicalState");
const createLabProcedures_1 = require("./createLabProcedures");
const createRisks_1 = require("./createRisks");
function createSectionList(intl, options) {
    return [
        (0, createCurrentCardiologicalState_1.createCurrentCardiologicalState)(intl, options),
        (0, createLabProcedures_1.createLabProcedures)(intl, options),
        (0, createRisks_1.createRisks)(intl, options)
    ];
}
